import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Link } from 'react-router-dom';
import i18n from "i18next";
import { withTranslation } from 'react-i18next';
import { withRouter } from "react-router-dom";
import {
    isBrowser,
    isMobile,
    isIOS
} from "react-device-detect";
import * as rdd from "react-device-detect";

import BlockBooksPromobook from './block-books-promobook';
import lazyComponent from '../../utilities/lazy-component';
const CarouselPromobooks = lazyComponent(() => import('../content/carousel-promobooks'), <div className="promo-cover-placeholder" />);

//SbC remember the last promo so returning visitors get the final layout on first paint
const PROMO_CACHE_KEY = 'SB_PROMO_BOOKS';

const readPromoCache = () => {
    try {
        const cached = localStorage.getItem(PROMO_CACHE_KEY);
        return cached === null ? undefined : JSON.parse(cached);
    } catch (e) {
        return undefined;
    }
}

const writePromoCache = (promoBooks) => {
    try {
        localStorage.setItem(PROMO_CACHE_KEY, JSON.stringify(promoBooks || null));
    } catch (e) {}
}

const BlockBooksPromo = inject("stores") (
    observer (
        class BlockBooksPromo extends Component {

            constructor(props) {
                super(props);
                this.props = props;

                this.storeUi = this.props.stores.storeUi;
                this.storeGeneral = this.props.stores.storeGeneral;
                this.storeContent = this.props.stores.storeContent;

                const cached = readPromoCache();
                this.state = {
                    promoBooks: cached || null,
                    loading: cached === undefined
                };
            }

            componentDidMount = async() => {
                this.mounted = true;
                let title = i18n.t("block.select_segment.header");
                let promoBooks;
                try {
                    promoBooks = await this.storeContent.getPromoBooks();
                    writePromoCache(promoBooks && promoBooks[0]);
                } finally {
                    if (this.mounted) {
                        this.setState({ promoBooks: promoBooks && promoBooks[0], title, loading: false });
                    }
                }

                // promoBooks.map((item) => {
                //     if ((item.sku === null || item.sku === '') && item.title !== null && item.title !== '') 
                //     {
                //         title = item.title
                //     }
                // });

            }

            componentWillUnmount() {
                this.mounted = false;
            }

            handleOnClick = () => {
                const url = '/site-explanation';
                this.props.history.push(url);
            }
  
            render() {              
                //SbC no placeholder: most of the time there is no promo, and a placeholder
                //that collapses afterwards shifts the whole page (CLS)
                if (this.state.loading) {
                    return null;
                }
                return (
                    this.state.promoBooks
                    ?    <div className="block__books--promo">
                            <div className="block__books--promo__block-title">
                                <h2>{this.state.promoBooks && this.state.promoBooks.title}</h2>
                                <h3>{this.state.promoBooks && this.state.promoBooks.subtitle}</h3>

                                {this.state.promoBooks && this.state.promoBooks.description &&
                                    <span className="block__books--promo__intro">
                                        {this.state.promoBooks.description}
                                    </span>
                                }
                            </div> 
                            {!rdd.isMobile 
                            ?   <ul
                                    className = "blocks__list blocks__list--covers blocks__list--promos"
                                >
                                    {this.state.promoBooks && this.state.promoBooks.sku1 &&
                                        <li>
                                            <BlockBooksPromobook
                                                sku = {this.state.promoBooks.sku1}
                                            />
                                        </li>
                                    }
                                    {this.state.promoBooks && this.state.promoBooks.sku2 &&
                                        <li>
                                            <BlockBooksPromobook
                                                sku = {this.state.promoBooks.sku2}
                                            />
                                        </li>
                                    }
                                    {this.state.promoBooks && this.state.promoBooks.sku3 &&
                                        <li>
                                            <BlockBooksPromobook
                                                sku = {this.state.promoBooks.sku3}
                                            />
                                        </li>
                                    }
                                </ul>
                            :   <CarouselPromobooks
                                    promoBooks = {this.state.promoBooks}
                                />
                            }
                        </div>
                    :   null
                )
            }
        }
    )
)

export default withTranslation()(withRouter(BlockBooksPromo));


